import { Group, Text } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { IFormInputSpecFileList } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a file list input.
 */
export default function FileListInputPreview({ spec }: { spec: IFormInputSpecFileList }) {
  return (
    <Group
      spacing={8}
      p={8}
      style={{
        border: '1px dashed #CED4DA',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
    >
      <IconUpload size={20} color="#868E96" />
      <Text size="sm" color="dimmed">
        Nahrať súbory (max. {spec.maxFiles})
      </Text>
    </Group>
  );
}
